const actions = {
    SET_AUTH_PARAMS: 'SET_AUTH_PARAMS',
    CLEAR_AUTH_PARAMS: 'CLEAR_AUTH_PARAMS',

    setAuthParams: (clientId, instituteId) => {
        return {
            type: actions.SET_AUTH_PARAMS,
            client_id: clientId,
            institute_id: instituteId,
        };
    },

    clearAuthParams: () => {
        return {
            type: actions.CLEAR_AUTH_PARAMS,
        };
    },
};

export default actions;

